
  import SearchCards from '@/components/SearchCards'
  import tableLoading from '@/components/tableLoading';
  import loaderComponent from '@/components/loaderComponent'
  import ImageHeader from '@/components/core/ImageHeader';
  import PackageCard from "@/components/PackageCard";
  import PlaceCard from "@/components/PlaceCard";
  import ActivityCard from "@/components/ActivityCard.vue";

  export default {
    components: {
      SearchCards,
      loaderComponent,
      ImageHeader,
      PackageCard,
      tableLoading,
      PlaceCard,
      ActivityCard
    },
    scrollToTop: true,
    head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          }
        ],
      }
    },
    data() {
      return {
        placeholderIndex: 0,
        placeholders: ['Beaches', 'Party Places', 'Best Sunset Places', 'Shacks', 'Yoga Places', 'Water sports',
          'Churches', 'Casinos', 'Temples', 'Shopping', 'Adventure Places'
        ],
        currentPlaceholder: '',
        title: 'Search',
        tagsData: [],
        search: '',
        isSearchClicked: false,
        listings: null,
        loading: true,
        listingLoading: false,
      }
    },
    fetchOnServer: false,

    async fetch() {
      //Get the list of page data
      this.tagsData = await fetch(this.$config.fetchUrl + '/api/tags').then(res =>
        res.text());
      this.tagsData = this.getCryptKey(this.tagsData);
      this.$nextTick(() => {
        this.loading = false;
      })
    },
    created() {

    },
    computed: {
      // Used for search function on the page
      filteredTagList() {
        if (this.tagsData) {
          return this.tagsData.filter(tag => {
            return (tag.name.toLowerCase().includes(this.search.toLowerCase().trim()))
          })
        } else {
          return []
        }
      },
      disableSearch() {
        let searchStr = "";
        if (this.search)
          searchStr = this.search.trim()
        const re = /^[a-zA-Z0-9\s,-]{3,}/;
        return re.test(String(searchStr).toLowerCase());
      }
    },

    mounted() {
      this.typingAnimation(); // Start the initial typing animation

      setInterval(() => {
        this.placeholderIndex = (this.placeholderIndex + 1) % this.placeholders.length;
        this.typingAnimation();
      }, 5000); // Change the value 3000 to the desired interval in milliseconds


      //END TYPING
      this.restoreFilters();
      let searchToken = this.$route.query.find ? this.$route.query.find : null;
      if (searchToken && searchToken.trim() != '' && searchToken.length > 2) {
        this.search = searchToken;
        this.getListings(searchToken)
      }
    },
    methods: {
      typingAnimation() {
        const placeholder = this.placeholders[this.placeholderIndex];
        let currentCharacter = 0;

        const typingInterval = setInterval(() => {
          this.currentPlaceholder = placeholder.slice(0, currentCharacter + 1);
          currentCharacter++;

          if (currentCharacter === placeholder.length) {
            clearInterval(typingInterval);
          }
        }, 100); // Adjust the typing speed by changing the interval time
      },
      catImage(image) {
        if (image && image.length > 0) {
          return image[0];
        } else {
          return '';
        }
      },

      // Store filters in Localstorage
      restoreFilters() {
        let filters = null
        if (localStorage.getItem("searchFilter")) {
          filters = JSON.parse(localStorage.getItem("searchFilter"))
          this.search = filters.search;
          if (this.search)
            this.getListings(this.search)
        }
      },

      // Store filters in Localstorage
      storeFilters() {
        let filters = {
          search: this.search,
        }
        localStorage.setItem("searchFilter", JSON.stringify(filters));
      },

      activitiesImage(post) {
        if (post.gallery && post.gallery.length > 0)
          return post.gallery[0]
        return '';
      },

      // Clear all dates, search and filters on click
      clearAll() {
        this.search = '';
        this.isSearchClicked = false;
      },
      // TO get SUBSCRIPTIONS using pagination
      getListings(queryStr = null) {
        this.storeFilters();
        this.listingLoading = true;
        // Add header for the API
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
        };
        if (queryStr) {
          // AXIOS api call to add review api
          this.$axios.get("/api/search/" + queryStr)
            .then(response => {
              this.isSearchClicked = true;
              let value = this.getCryptKey(response.data);
              this.listings = value;
              this.$nextTick(() => {
                this.listingLoading = false;
              })
            })
            .catch(error => {
              this.$nextTick(() => {
                this.listingLoading = false;
              })
            })
            .finally(() => {
              this.$nextTick(() => {
                this.listingLoading = false;
              })
            })
        } else {
          this.listings = null;
          this.listingLoading = false;
        }
      },
    }
  }
